"use client";

import { ExternalLink, Loader2, RefreshCcw } from "lucide-react";
import { H2, H4 } from "~/components/common/Typography";
import { Button } from "~/components/ui/button";
import { useProcessVideo } from "~/hooks/useProcessVideo";
import { type SelectVideo } from "~/server/db/videos/schema";

import YouTubePlayer from "./YouTubePlayer";

export default function VideoWithErrors({ video }: { video: SelectVideo }) {
  const { sourceId } = video;
  const { isRunning, processVideo } = useProcessVideo(video.id);

  return (
    <div className="rounded-r-md border bg-background/70 backdrop-blur-md">
      <div className="flex flex-col md:flex-row">
        <div className="w-full md:w-1/2 md:pr-2">
          <div className="w-full">
            <YouTubePlayer
              sourceId={video.sourceId}
              autoPlay={false}
              autoPause={false}
              seekTime={null}
              duration={null}
              start={null}
              playTiming={null}
            />
          </div>
        </div>
        <div className="mt-2 flex w-full flex-col pl-4 pr-4 pt-0 md:mt-0 md:pt-4">
          <H2 className="mb-4 text-red-500">
            あら
            <ruby>
              問題<rt>もんだい</rt>
            </ruby>
            が
            <ruby>
              発生<rt>はっせい</rt>
            </ruby>
            しちゃった！
          </H2>
          <H4 className="mb-4">Sorry, this video could not be processed:</H4>
          <div className="mb-8 line-clamp-1 italic">
            {video.lastProcessedError ?? "Unknown error"}
          </div>
          <div className="mb-4 flex gap-2">
            <Button
              onClick={processVideo}
              disabled={isRunning}
              variant="outline"
            >
              {isRunning ? (
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
              ) : (
                <RefreshCcw className="mr-2 h-4 w-4" />
              )}
              Retry
            </Button>
            <Button asChild variant="outline">
              <a
                href={`https://www.youtube.com/watch?v=${sourceId}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <ExternalLink className="mr-2 h-4 w-4" />
                Visit YouTube
              </a>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
